import moment from 'moment';

export const dateSort = (dateA: string, dateB: string) =>
  moment(dateA).diff(moment(dateB));

export const defaultSort = (a: string | number, b: string | number) => {
  if (a < b) return -1;
  if (b < a) return 1;
  return 0;
};
